export interface OptionType {
  value: string;
  label: string;
}

export const createOption = (text: string): OptionType => ({
  value: text,
  label: text,
});

export const createOptions = (texts: string[]): OptionType[] =>
  texts.map(createOption);
